import styled from '@emotion/styled';

export const StyledCardBody = styled.div`
  margin-top: 1rem;
`;
